import { Injectable } from '@angular/core';
import { AccreditationDataService } from '../shared/accreditation-data.service';
import { UserService } from '../shared/user.service';
import { BehaviorSubject, filter, from, switchMap, take } from 'rxjs';
import { AccreditationDto } from 'src/app/shared/models/AccreditationDto.model';
import { AppSettingsService } from '../app-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseResponseStatus } from 'src/app/shared/models/BaseResponseDto.model';
import { CookieService } from 'ngx-cookie-service';
import { GeneralSettingsService } from '../shared/general-settings.service';
import { SystemFeatureFlagConsts } from 'src/app/shared/consts/SystemFeatureFlags.consts';

// declare global {
//   interface Window {
//     verifyInvestor: any;
//   }
// }

@Injectable({
  providedIn: 'root'
})
export class LpAccreditationService {
  private _allRequireAccreditationUpdate$ = new BehaviorSubject<void>(null);

  allRequireAccreditation$ = this._allRequireAccreditationUpdate$.pipe(
    switchMap(_ => this.generalSettings.systemFeatureFlagKeysValues$),
    filter(featureFlagKeysValues => !!featureFlagKeysValues[SystemFeatureFlagConsts.SystemFeatureFlagAccreditationOn]),
    switchMap(_ => this.accreditationDataService.getAllRequireAccreditation()));

  constructor(
    private accreditationDataService: AccreditationDataService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appSettingService: AppSettingsService,
    private generalSettings: GeneralSettingsService
  ) {

    this.activatedRoute.queryParams.pipe(
      filter(params => !!params['accReq']),
      switchMap(params => this.accreditationDataService.getById(params['accReq'])),
      take(1)
    ).subscribe({
      next: res => {
        if (!!res && res.responseStatus === BaseResponseStatus.Success) {
          this.router.navigate([], {
            queryParams: {
              // 'accReq': null
            }
            // queryParamsHandling: 'merge'
          })
          this.userService.refreshedClientDetails$.next(null);
          this.openAccreditationFlow(res);
        }
      },
      error: err => { }
    })
  }

  openAccreditationFlow(acc: AccreditationDto) {
    const token = this.appSettingService.verifyInvestorToken;
    const identifier = acc.providerId;
    const portal_name = 'Covercy';
    const deal_name = acc.organizationName;
    const vr_type = 'ai';
    this.addListener();
    (window as any).verifyInvestor(token, identifier, portal_name, deal_name, vr_type);

    this.accreditationDataService.updateViewInvestorStatus(acc).pipe(take(1)).subscribe();
  }

  addListener(){
    window.document.addEventListener('modalClosed', this.handleEvent.bind(this));
  }

  handleEvent(e) {
    this._allRequireAccreditationUpdate$.next();
    window.document.removeEventListener('modalClosed', this.handleEvent.bind(this));
  }
}
